import React from 'react';
import { useBooking } from '../context/BookingContext';
import VehicleCard from './components/VehicleCard';
import RentalPackageCard from './components/RentalPackageCard';
import EmptyState from '../components/EmptyState';
import './CabDetails.css';

const CabDetails = () => {
  const { booking } = useBooking();
  const { selectedVehicle, selectedPackage } = booking;

  if (!selectedVehicle && !selectedPackage) {
    return (
      <div className="cd-wrap">
        <EmptyState
          title="No cab selected"
          description="Pick a cab from the list to see details."
        />
      </div>
    );
  }

  return (
    <div className="cd-wrap">
      <h2 className="cd-title">Selected Cab</h2>
      {selectedVehicle && (
        <VehicleCard vehicle={selectedVehicle} onSelect={() => {}} />
      )}
      {selectedPackage && (
        <RentalPackageCard pkg={selectedPackage} onSelect={() => {}} />
      )}
    </div>
  );
};

export default CabDetails;